/* 
  Source: https://inclusive-components.design/tooltips-toggletips/ (Heydon Pickering)
*/

(function() {
  // Get all the toggletip buttons
  var toggletipTexts = document.querySelectorAll('[data-toggletip]');

  // Iterate over them
  Array.prototype.forEach.call(toggletipTexts, function(toggletipText) {
    // Create the container element
    var container = document.createElement('span');
    container.setAttribute('class', 'c-tooltip');
    
    // Put it before the original element in the DOM
    toggletipText.parentNode.insertBefore(container, toggletipText);
    
    // Create the button element
    var toggletip = document.createElement('button');

    // Check the data attributes
    var tooltip_aria_label = toggletipText.parentElement.getAttribute('data-js-tooltip-label');
    var tooltip_exposed_icon = toggletipText.parentElement.getAttribute('data-js-tooltip-icon');
    var tooltip_exposed_text = toggletipText.parentElement.getAttribute('data-js-tooltip-text');
    var tooltip_exposed_img = toggletipText.parentElement.getAttribute('data-js-tooltip-img');
    // Get the class to give to bubble for its positioning
    var tooltip_bubble_pos_class = toggletipText.parentElement.getAttribute('data-js-bubble-class-position');

    toggletip.setAttribute('type', 'button');
    toggletip.setAttribute('aria-label', tooltip_aria_label);
    toggletip.setAttribute('data-toggletip-content', toggletipText.innerHTML);
    
    // Check if is icon or text
    if (tooltip_exposed_icon) {
      toggletip.innerHTML = '<svg class="c-icon"><use xlink:href="#' + tooltip_exposed_icon + '" /></svg>';
    } else if ( tooltip_exposed_text ) {
      toggletip.textContent = tooltip_exposed_text ;
    } else if (tooltip_exposed_img) {
      toggletip.innerHTML = '<img src="' + tooltip_exposed_img + '" alt="" />';
    }

    // Place the button element in the container
    container.appendChild(toggletip);
    
    // Create the live region
    var liveRegion = document.createElement('span');
    liveRegion.setAttribute('role', 'status');
    
    // Place the live region in the container
    container.appendChild(liveRegion);
    
    // Remove the original element
    toggletipText.parentNode.removeChild(toggletipText);
    
    // Build `data-tooltip-content` 
    var message = toggletip.getAttribute('data-toggletip-content');
    toggletip.setAttribute('data-toggletip-content', message);
    toggletip.removeAttribute('title');

    // Get the message from the data-content element
    var message = toggletip.getAttribute('data-toggletip-content');

    // Get the live region element
    var liveRegion = toggletip.nextElementSibling;

    // Toggle the message
    toggletip.addEventListener('click', function() {
        liveRegion.innerHTML = '';
        window.setTimeout(function() {
          liveRegion.innerHTML = '<span class="c-tooltip__bubble '+ tooltip_bubble_pos_class +'">'+ message +'</span>';
        }, 100);
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (toggletip !== e.target) {
        liveRegion.innerHTML = '';
      }                        
    });

    // Remove toggletip on ESC
    toggletip.addEventListener('keydown', function(e) {
      if ((e.keyCode || e.which) === 27)
      liveRegion.innerHTML = '';
    });
  });
}());